module.exports = __webpack_public_path__ + "img/avatar2.3197db74.jpg";